import "./index.css";
import {createRoot} from "react-dom/client";
import {Calendar} from "./Calendar";

createRoot(document.getElementById("root")).render(<Calendar />);
